
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.872 1.257a.818.818 0 00-.17.017A8.464 8.464 0 00.374 7.06a8.457 8.457 0 005.79 10.626 8.457 8.457 0 0010.482-6.047.818.818 0 00-.59-.995.818.818 0 00-.995.59 6.82 6.82 0 01-4.871 4.907 6.816 6.816 0 01-3.582-.032 6.816 6.816 0 01.433-13.232.818.818 0 00.63-.971.818.818 0 00-.799-.648z","font-family":"sans-serif","overflow":"visible"}}),_c('path',{attrs:{"d":"M9.546 0a.818.818 0 00-.818.818v7.637a.818.818 0 00.818.818h7.637A.818.818 0 0018 8.455 8.451 8.451 0 0012.78.643 8.45 8.45 0 009.546 0zm.819 1.798c.607.076 1.223.123 1.791.358a6.812 6.812 0 013.689 3.688c.235.568.282 1.185.358 1.792h-5.838z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    